var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHorizontalBarsIconDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 16,
    viewBox: "0 0 15 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.4375 9.09277H2.5625C1.625 9.09277 1.25 9.49277 1.25 10.4865V13.0115C1.25 14.0053 1.625 14.4053 2.5625 14.4053H12.4375C13.375 14.4053 13.75 14.0053 13.75 13.0115V10.4865C13.75 9.49277 13.375 9.09277 12.4375 9.09277Z",
    fill: "#4a4a4a"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.0625 1.90527H2.5625C1.625 1.90527 1.25 2.30527 1.25 3.29902V5.82402C1.25 6.81777 1.625 7.21777 2.5625 7.21777H8.0625C9 7.21777 9.375 6.81777 9.375 5.82402V3.29902C9.375 2.30527 9 1.90527 8.0625 1.90527Z",
    fill: "#4a4a4a"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHorizontalBarsIconDark);
export default __webpack_public_path__ + "static/media/horizontal-bars-icon-dark.30b8d7da7e0b9458ac0e91223c672191.svg";
export { ForwardRef as ReactComponent };